import { ReviewPageProps } from '@/pages/r/[userId]'
import { Box } from '@chakra-ui/react'
import Head from 'next/head'
import Contact from './Contact/Contact'
import HeaderVideo from './HeaderAndVideo/HeaderVideo'

const Review = (props: ReviewPageProps) => {
  return (
    <Box>
      <Head>
        <title>Review | Chacra Software Solutions</title>
      </Head>
      <HeaderVideo review={props.review} />
      <Contact review={props.review} />
    </Box>
  )
}

export default Review
